<template>
  <el-row class="container">
    <section class="content-container">
      <div class="navbar">
        <div style="flex: 0 0 300px; display: flex">
          <div class="logo">辉耀</div>
          <div class="breadcrumb-container">
            <span class="el-icon-s-fold"></span>
            <span class="title">当前位置：</span>
            <div>{{ breadcrumb() }}</div>
          </div>
        </div>

        <div class="menu">
          <el-menu :default-active="$route.path" router mode="horizontal" unique-opened>
            <template v-for="(item, index) in menu">
              <!--有多个节点-->
              <el-submenu :index="index + ''" v-if="!item.leaf" :key="`menu-item-${index}`">
                <template slot="title">{{ item.name }}</template>
                <template v-if="item.children">
                  <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path">
                    <template v-if="!child.hidden">
                      <div @click.stop="routerTo(child)">
                        <div class="menu-title">
                          <!--                    <img :src="require(`../assets/images/${child.icon}`)" alt="">-->
                          <span slot="title">{{ child.name }}</span>
                        </div>
                      </div>
                    </template>
                  </el-menu-item>
                </template>
              </el-submenu>

              <!--只有一个节点-->
              <el-menu-item v-if="item.leaf" :index="item.path" :key="index">
                <div class="menu-title" @click.stop="routerTo(item)">
                  <!--                <img :src="require(`../assets/images/${item.icon}`)" alt="">-->
                  <span slot="title">{{ item.name }}</span>
                </div>
              </el-menu-item>
            </template>
          </el-menu>
        </div>

        <div class="username">
          <el-dropdown @command="handleCommand">
            <span>
              欢迎你!
              <el-tag size="small" type="info">{{ user.u_name }}({{ user.u_account }})</el-tag>
              <el-tag size="small">{{ matchUserLevelLabel(user.u_level) }}</el-tag>
            </span>
            <i class="el-icon-caret-bottom"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="CHANGE_PASSWORD">
                修改密码
              </el-dropdown-item>
              <el-dropdown-item command="LOGOUT" divided>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <el-col :span="24" class="content-wrapper" id="content-wrapper">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-col>

      <el-dialog :visible.sync="changePasswordDialog">
        <el-form label-width="80px" label-position="left">
          <el-form-item label="旧密码">
            <el-input v-model="oldPassword"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="newPassword"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="onChangePassword()">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-row>
</template>
<script>
import index from './index.js';

export default index;
</script>
<style scoped lang="less">
@import 'index';
</style>
